import { useRef } from 'react'

let counter = 0

// Unique id per component instance (React 17 has no useId).
// Inline SVGs rendered several times on a page need their own clipPath/mask ids,
// otherwise url(#id) can resolve to a copy inside a hidden (display: none) container.
const useSvgId = (prefix) => {
  const id = useRef(null)
  if (id.current === null) {
    counter += 1
    id.current = `${prefix}-${counter}`
  }
  return id.current
}

export default useSvgId
